<template>
  <div class="app_share " ref="main">
    <div class="inner_box canvas_box">
      <div id="mycanvas" ref="mycanvas">
        <div class="out_box1">
          <div class="box1_title1">
            <span v-for="p in '明楚王墓知识服务'" :key="p">{{ p }}</span>
          </div>
          <div class="box1_title2">{{ currName }}</div>
          <div class="box1_title3">基础信息</div>
          <div class="box1_title4">
            <p v-for="(el, elI) in jbxxInfo" :key="elI">
              {{ el.relationshipName }}：<span>{{ el.attributeValue }}</span>
            </p>
          </div>

          <div class="box1_title5">{{ jbxxContent }}</div>
          <div class="box1_title3" v-if="glzyInfo.length > 0">关联资源</div>
          <div class="box1_title6" v-if="glzyInfo.length > 0">
            <div class="item_box" v-for="(el, elI) in glzyInfo" :key="elI">
              <div class="gl_img">
                <img :src="`${imgUrl}${el.fileThumbnail}`" />
                <!-- <img v-if="el.materialCategory == 'FILE_TYPE_VIDEO'" :src="require(`../../public/videoCover/${el.materialTitle}.png`)" />
                <img v-else :src="`${imgUrl}${el.fileThumbnail}`" /> -->
                <div class="video-icon" v-if="el.materialCategory == 'KGS_LINKDATA_VIDEO'">
                  <i class="iconfont icon-mapbofang"></i>
                </div>
              </div>
            </div>

            <div class="item_box" v-if="glzyInfo.length === 0">暂无资源</div>
          </div>
        </div>

        <div class="out_box2">
          <div class="sys_box">
            <div class="sys_img">
              <img src="@/assets/img/saoyisao.png" alt="" />
            </div>
            <div class="sys_text">
              <p>微信扫一扫</p>
              <p>分享给好友</p>
            </div>
          </div>
          <div class="ewm_box">
            <div id="qrid"></div>
            <!-- <img src="@/assets/img/ewm.png" alt="" /> -->
          </div>
        </div>
      </div>

      <!-- <div class="out_box3">
        <div class="box3_item" :class="{ 'copy-button': elI === 0 }" v-for="(el, elI) in shareList" :key="elI" @click="handleItemClick(el.label)">
          <div class="img_box"><img :src="el.src" alt="" /></div>
          <div class="text_box">{{ el.label }}</div>
        </div>
      </div> -->
    </div>
    <!-- 关闭 -->
    <div class="details-picture-close" @click="handleCloes">关闭</div>
    <!-- 保存并分享 -->
    <div class="share_btn" @click="handleItemClick('saveImg')">保存并分享</div>
  </div>
</template>

<script>
// href = this.$router.resolve({ path: '/versionsComparison', query: { dataInfo: JSON.stringify(data) } }).href
// window.open(href, '_blank')

import Clipboard from 'clipboard'
import html2canvas from 'html2canvas'
import KgMapFun from '@/utils/KgMapFun.js'
import { imgUrl, baseUrlWB, baseUrlQQ } from '@/api/http/baseURL'
export default {
  name: 'app_share',
  props: {
    nameOrId: {
      type: String,
      default: ''
    },
    dataInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      imgUrl: null,
      shareList: [
        { label: '复制链接', src: require('../assets/img/lianjie.png') },
        { label: '下载图片', src: require('../assets/img/xiazai.png') },
        { label: 'QQ空间', src: require('../assets/img/QQkongjian.png') },
        { label: '新浪微博', src: require('../assets/img/weibo.png') }
      ],
      clipboard: null, // 添加 clipboard 属性

      copyText: '要复制的内容',
      jbxxInfo: [],
      jbxxContent: '',
      xgtjInfo: [],
      rwspInfo: [],
      shjdInfo: [],
      glzyInfo: [],
      gxtpInfo: [],
      currName: ''
    }
  },
  mounted() {
    this.imgUrl = imgUrl
    this.currName = this.dataInfo.currName
    this.jbxxInfo = this.dataInfo.jbxxInfo.slice(0, 4).map(el => {
      let relationshipName = KgMapFun.filterReplaceHTML(el.relationshipName)
      let attributeValue = KgMapFun.filterReplaceHTML(el.attributeValue)
      return {
        relationshipName,
        attributeValue
      }
    })

    this.jbxxContent = this.dataInfo.jbxxContent
    // console.log(this.dataInfo.jbxxContent)

    this.jbxxContent = KgMapFun.filterReplaceHTML(this.jbxxContent)
    this.jbxxContent = this.jbxxContent.replace(/&deg;/gi, '°')
    this.xgtjInfo = this.dataInfo.xgtjInfo
    this.rwspInfo = this.dataInfo.rwspInfo
    this.shjdInfo = this.dataInfo.shjdInfo
    this.glzyInfo = this.dataInfo.glzyInfo.slice(0, 3)
    this.gxtpInf = this.dataInfo.gxtpInfo

    var qrstr = location.origin
    let font = document.documentElement.style.fontSize
    let size = parseInt(font) / 100

    this.$EventBus.$on('createImage', () => {
      this.saveImg('mycanvas')
    })

    this.$('#qrid').qrcode({ width: 182 * size, height: 182 * size, text: qrstr }) //指定二维码大小
    // 创建剪贴板实例
    this.clipboard = new Clipboard('.copy-button', {
      text: () => this.copyText
    })

    // 监听复制成功事件
    this.clipboard.on('success', () => {
      this.$message.success('复制成功！')
    })

    // 监听复制失败事件
    this.clipboard.on('error', () => {
      this.$message.error('复制失败，请手动复制')
    })
    this.copyText = window.location.origin + '?nameOrId=' + this.nameOrId
  },
  beforeDestroy() {
    // 销毁剪贴板实例
    this.clipboard.destroy()
    this.$EventBus.$off('createImage')
  },
  methods: {
    handleCloes() {
      this.$parent.hasShare = false
      // if (e.target === this.$refs.main) {
      //   // 处理页面关闭
      //   this.$parent.hasShare = false
      //   console.log(this.$parent, this.$parent.hasShare)
      // }
    },

    handleItemClick(type) {
      switch (type) {
        case '复制链接':
          this.clipboard.onClick('.copy-button')
          break
        case 'saveImg':
          this.saveImg('mycanvas')
          break
        case 'QQ空间':
          this.shareToQZone()
          break
        case '新浪微博':
          this.shareToWeibo()
          break
      }
    },
    saveImg(val) {
      console.log('🌏 =>', '生成图片')
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      // 先获取你要转换为img的dom节点
      var node = document.getElementById(val) //传入的id名称
      var width = node.offsetWidth //dom宽
      var height = node.offsetHeight //dom高
      var scale = 1.5 //放大倍数 这个相当于清晰度 调大一点更清晰一点
      html2canvas(node, {
        width: width,
        heigth: height,
        backgroundColor: '#ffffff', //背景颜色 为null是透明
        dpi: window.devicePixelRatio * 1, //按屏幕像素比增加像素
        scale: scale,
        X: 0,
        Y: 0,
        scrollX: -3, //如果左边多个白边 设置该偏移-3 或者更多
        scrollY: 0,
        useCORS: true, //是否使用CORS从服务器加载图像 !!!
        allowTaint: true //是否允许跨域图像污染画布  !!!
      }).then(canvas => {
        var url = canvas.toDataURL() //这里上面不设值cors会报错
        var a = document.createElement('a') //创建一个a标签 用来下载
        a.download = '明楚王墓' //设置下载的图片名称
        var event = new MouseEvent('click') //增加一个点击事件
        a.href = url //此处的url为base64格式的图片资源
        a.dispatchEvent(event) //触发a的单击事件 即可完成下载
        this.$linkWx({ url: '/pages/CreateImage', base64: url, instance: this.currName })
        // canvas.toBlob(blob => {
        //   var url = URL.createObjectURL(blob)
        //   console.log(url)
        //   var a = document.createElement('a')
        //   a.href = url
        //   a.download = '明楚王墓.png'
        //   var event = new MouseEvent('click')
        //   a.dispatchEvent(event)
        // })
      })
    },
    shareToQZone() {
      // KgMapFun.filterReplaceHTML
      var p = {
        url: `${location.origin}/?nameOrId=${this.nameOrId}` /*获取URL，可加上来自分享到QQ标识，方便统计*/,
        desc: '来自明楚王墓知识服务的分享' /*分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/,
        title: this.currName /*分享标题(可选)*/,
        summary: this.jbxxContent /*分享描述(可选)*/,
        // pics: 'http://image102.360doc.com/DownloadImg/2016/12/2021/87403702_2' /*分享图片(可选)*/,
        // flash: '' /*视频地址(可选)*/,
        //commonClient : true, /*客户端嵌入标志*/
        site: '明楚王墓昭园' /*分享来源 (可选) ，如：QQ分享*/
      }

      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var target_url = baseUrlQQ + s.join('&')

      window.open(target_url, 'qq', 'height=520, width=720')
    },
    shareToWeibo() {
      // KgMapFun.filterReplaceHTML
      var p = {
        url: `#${location.origin}/?nameOrId=${this.nameOrId}` /*获取URL，可加上来自分享到QQ标识，方便统计*/,
        // desc: '来自明楚王墓知识服务的分享' /*分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/,
        title: '来自明楚王墓知识服务的分享' /*分享标题(可选)*/
      }

      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var target_url = baseUrlWB + s.join('&')

      window.open(target_url, 'Weibo', 'height=520, width=720')
    }
  }
}
</script>

<style lang='scss' scoped>
.app_share {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  line-height: 1;
  opacity: 0;
  // background-color: rgba(0, 0, 0, 0.5);

  pointer-events: none;
  overflow: auto;
  .inner_box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10.27rem;

    background-image: url('../assets/img/share_bg.png');
    background-size: 100% 100%;

    .out_box1 {
      // width: 5.2rem;
      height: 11rem;
      padding: 0 0.6rem;
      padding-top: 0.88rem;

      .box1_title1 {
        display: flex;
        justify-content: space-between;
        color: #33764e;
        font-size: 0.58rem;
        margin-bottom: 0.82rem;
        span {
          // width: 100%;
          // text-align: center;
          display: inline-block;
          position: relative;
          // border-right: 1px solid;
        }
        span::before {
          content: '';
          position: absolute;
          height: 90%;
          width: 100%;
          border-right: 0.04rem solid;
          transform: translate(50%, 10%);
        }
        span:last-child::before {
          content: '';
          width: 0;
          height: 0;
        }
      }

      .box1_title2 {
        color: #252525;
        font-size: 0.44rem;
        margin-bottom: 0.5rem;
      }

      .box1_title3 {
        color: #33764e;
        font-size: 0.38rem;
        margin-bottom: 0.4rem;
      }

      .box1_title4 {
        display: flex;
        flex-wrap: wrap;
        font-size: 0.38rem;

        p {
          width: 50%;
          color: #727d72;
          height: 0.38rem;
          margin-bottom: 0.35rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          span {
            color: #4c4948;
          }
        }
      }

      .box1_title5 {
        height: 2.32rem;
        font-size: 0.38rem;
        line-height: 1.5;
        color: #4c4948;
        margin-bottom: 0.2rem;
        text-align: justify;
        display: -webkit-box; /* 使用弹性盒子布局 */
        -webkit-box-orient: vertical; /* 设置为垂直方向布局 */
        -webkit-line-clamp: 4; /* 显示的行数 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
      }
      .box1_title6 {
        height: 2.02rem;
        display: flex;
        gap: 0.1rem;
        // margin-bottom: 0.2rem;
        .item_box {
          width: 2.82rem;
          height: 100%;
          border-radius: 0.1rem;
          // background-color: skyblue;
          text-align: center;
          font-size: 0.44rem;
          color: #000;
          line-height: 2.02rem;
          box-shadow: 0px 0px 0.1rem rgba(0, 0, 0, 0.15);

          .gl_img {
            position: relative;
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
            }
            .video-icon {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.5);
              left: 0;
              top: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                font-size: 0.4rem;
                color: #fff;
              }
            }
          }
        }
      }
    }

    .out_box2 {
      height: 2.35rem;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1.2rem;
      .sys_box {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        .sys_img {
          width: 0.88rem;
          height: 0.88rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .sys_text {
          font-size: 0.34rem;
          line-height: 1.5;
          color: #4c4948;
        }
      }

      .ewm_box {
        width: 1.82rem;
        height: 1.82rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .out_box3 {
      position: absolute;
      bottom: 0.45rem;
      left: 0;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0 1.1rem;
      .box3_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.2rem;
        img {
          width: 1.2rem;
          height: 1.2rem;
        }
        .text_box {
          color: #f0fff7;
          font-size: 0.3rem;
        }
      }
    }
  }

  .share_btn {
    position: absolute;
    bottom: 1.56rem;
    left: 0;
    right: 0;
    margin: auto;
    width: 80%;
    height: 0.8rem;
    border-radius: 0.4rem;
    background-color: rgba(170, 201, 177, 0.7);
    text-align: center;
    line-height: 0.8rem;
    font-size: 0.4rem;
    color: #fff;
  }
  // 关闭
  .details-picture-close {
    position: absolute;
    width: 0.96rem;
    top: 1.56rem;
    right: 1rem;
    color: #fff;
    font-size: 0.38rem;
  }
}
#mycanvas {
  background-image: url('../assets/img/share_bg.png');
  background-size: 100% 100%;
}
</style>